import items from './items'

export default {
  putImage(img_id, coordinates) {
    return items.editItem(`groups/image/${img_id}`, { ...coordinates })
  },
  resendInvitations(id, params) {
    return items.createItem(`groups/${id}/invitations_resend`, { ...params })
  },
  resendInvitation(id, member_id) {
    return items.createItem(`groups/${id}/invitation_resend/${member_id}`)
  },
  removeMember(id, member_id) {
    return items.deleteItem(`groups/${id}/users/${member_id}`)
  },
  removeAdmin(id, member_id) {
    return items.deleteItem(`groups/${id}/admins/${member_id}`)
  },
  removeInvitation(id, member_id) {
    return items.deleteItem(`groups/${id}/invitations/${member_id}`)
  },
  removeInvitationDecline(id, member_id) {
    return items.deleteItem(`groups/${id}/invitations_decline/${member_id}`)
  },
}
